export const buildOptions = (answerValues) => {
	let options = [];
	answerValues.forEach(a => {
		let option = a.options;
		if (Array.isArray(option)) {
			option.forEach(a => {
				let option = a;
				options[option] >= 0 ? options[option] += 1 : options[option] = 1;
			});
		}
		else if (option) {
			options[option] >= 0 ? options[option] += 1 : options[option] = 1;
		}
	});
	return options;
};

export const buildDimensionOptions = (answerValues) => {
	let options = [{}, {}, {}];
	answerValues.forEach(a => {
		let option = a.options;
		options[0][option[0]] >= 0 ? options[0][option[0]] += 1 : options[0][option[0]] = 1;
		options[1][option[1]] >= 0 ? options[1][option[1]] += 1 : options[1][option[1]] = 1;
		options[2][option[2]] >= 0 ? options[2][option[2]] += 1 : options[2][option[2]] = 1;
	});
	return options;
};

export const buildAnswerVariants = (answerValues) => answerValues.reduce((acc, current) => {
	if (Array.isArray(current.answer)) {
		let answer = current.answer;
		answer.forEach(element => {
			acc[element] ? acc[element] += 1 : acc[element] = 1;
		});
	} else {
		acc[current.answer] ? acc[current.answer] += 1 : acc[current.answer] = 1;
	}
	return acc;
}, {});

export const buildTitleOptions = (answerVariants, answers) => {
	let gender = {};
	for (let key in answerVariants) {
		let title = answers[key].title;
		gender[title] = answerVariants[key];
	}
	return gender;
};

export const getTotalAnswers = (options) => {
	const totalValue = Object.values(options);
	const sumTotal = totalValue.reduce((acc, curr) => {
		return acc + curr;
	});
	return sumTotal;
};

export const getColorScale = (percentPlants, colorScale) => {
	const colorsNature = [];
	percentPlants.forEach((plant) => {
		colorsNature.push(colorScale(plant.y).hex());
	});
	return colorsNature;
};

export const buildChartData = (options) => {
	let optionsData = [];
	for (let key in options) {
		optionsData.push({ x: key, y: options[key] });
	}
	return optionsData;
};




// WEBPACK FOOTER //
// ./src/utils/survey.js